import { Tenant } from "store/environments/environment-types";
import { StorageAccount } from "store/storage-accounts/storage-accounts-types";
import { Mailbox } from "store/environments/tenants/mailboxes/mailboxes-types";
import { Studio } from "store/environments/tenants/studio/studio-types";

export interface IWorkflowStep {
    id: string;
    order: number;
    status: WorkflowStepStatus;
    createdOn: Date;
    logs?: string | null;
    description?: string | null;
    errorMessage?: string | null;
}

export interface IWorkflowStepWithData<TData> extends IWorkflowStep {
    data: TData;
}

export interface IWorkflow<TStep extends IWorkflowStepWithData<unknown>> {
    id: string;
    status: WorkflowStatus;
    createdOn: Date;
    createdBy: string;
    steps: ReadonlyArray<TStep>;
}

export interface IWorkflowWithData<TStep extends IWorkflowStep, TData> {
    id: string;
    status: WorkflowStatus;
    createdOn: Date;
    createdBy: string;
    data?: TData | null;
    steps: ReadonlyArray<TStep>;
}

export interface ManagementPolicyRulesWorkflow extends IWorkflow<ManagementPolicyRulesWorkflowStep> {
    steps: ReadonlyArray<ManagementPolicyRulesWorkflowStep>;
}

export interface ManagementPolicyRulesWorkflowStep extends IWorkflowStepWithData<
    Tenant<StorageAccount>
> {
    data: Tenant<StorageAccount>;
}

export interface MailboxesWorkflow extends IWorkflow<MailboxesWorkflowStep> {
    steps: ReadonlyArray<MailboxesWorkflowStep>;
}

export interface MailboxesWorkflowStep extends IWorkflowStepWithData<
    Tenant<Mailbox>
> {
    type: MailboxesWorkflowType;
}

export interface StudioWorkflow extends IWorkflowWithData<
    StudioWorkflowStep,
    Studio
> {
    type: StudioWorkflowType;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface StudioWorkflowStep extends IWorkflowStep {}

export enum StudioWorkflowType {
    Integration = 0,
    RotateClientSecret = 1,
}

export enum MailboxesWorkflowType {
    Create = 0,
    Update = 1,
}

export enum WorkflowStatus {
    NotStarted = 0,
    InProgress = 1,
    Failed = 2,
    Succeeded = 3,
    Terminated = 4,
}

export enum WorkflowStepStatus {
    Pending = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
    Skipped = 4,
}

export enum FailureAction {
    Retry = 0,
    Skip = 1,
}
